import { keepPreviousData, useQuery } from "@tanstack/react-query";
import {
  AuditLogControllerApi,
  GetAllAuditLogDateRangeTypeEnum,
} from "../../../services";
import {
  DGT_Pagination,
  getConfigObject,
  useBaseContent,
} from "../../../utils/utils";

interface Props {
  pagination: DGT_Pagination;
  sortBy?: string;
  sortDirection?: string;
  fromDate?: string;
  toDate?: string;
  dateRangeType?: GetAllAuditLogDateRangeTypeEnum;
  patient?: string;
  user?: string;
  category?: string;
  action?: string;
  logType?: string;
  ipAddress?: string;
  xTENANTID?: string;
}

export const AUDIT_LOG_LIST_QUERY_KEY = "audit-log-list";

export type OptionData = {
  name: string;
  uuid: string;
};

/**
 *
 * @author Rajkumar Rathod
 */
export const useAuditLogList = (props: Props): useBaseContent<OptionData> => {
  return useQuery({
    queryKey: [AUDIT_LOG_LIST_QUERY_KEY, props],
    refetchOnWindowFocus: false,
    placeholderData: keepPreviousData,
    queryFn: async () =>
      await new AuditLogControllerApi(getConfigObject())
        .getAllAuditLog(
          props.pagination.page,
          props.pagination.pageSize,
          props.sortBy,
          props.sortDirection,
          props.fromDate,
          props.toDate,
          props.patient,
          props.user,
          props.category,
          props.action,
          props.logType,
          props.ipAddress,
          props.dateRangeType,
          props.xTENANTID
        )
        .then((res) => res?.data),
  });
};
